import axios from 'axios'
import { push } from 'react-router-redux'
import { logout } from '../actions/auth'
import { MAKE_API_CALL } from '../actions/types'
import { _setFrom } from '../reducers/app'
import { notification } from 'antd'
import config from 'config'

const handleError = (error, dispatch) => {
  if (error.response && error.response.status === 401 && error.response.data) {
    // check if the token has expired
    if (error.response.data.error && error.response.data.error === 'invalid_token') {
      dispatch(logout())
      dispatch(_setFrom(''))
      return Promise.reject(error)
    } else {
      dispatch(logout())
      dispatch(_setFrom(''))
      return Promise.reject(error)
    }
    //handle user no access to resource
  } else if (error.response && error.response.status === 403) {
    dispatch(push('/simulator'))
    notification.open({
      type: 'error',
      message: error.response.data.responseMessage,
    })
    return Promise.reject(error)
  } else if (error.response && error.response.status === 500) {
    notification.open({
      type: 'error',
      message: 'System error',
    })
    return Promise.reject(error)
  } else if (!error.response) {
    dispatch(logout())
    dispatch(_setFrom(''))
    return Promise.reject(error)
  } else if (!error.response.status && error.request) {
    dispatch(logout())
    dispatch(_setFrom(''))
    return Promise.reject(error)
  }

  //show network error
}

const baseUrl = config.PAYMENT_SERVICE_URL

const handleApiCall = (dispatch, process, success, failure, skipAuthHeader) => {
  const instance = axios.create({
    baseURL: baseUrl,
  })

  //set up the request interceptor here
  instance.interceptors.request.use(
    function(config) {
      // Do something before request is sent
      if (!skipAuthHeader) {
        const authorization = window.localStorage.getItem('app.Authorization')

        if (!authorization) {
          dispatch(logout())
          return Promise.reject('user not logged in')
        }

        config.headers = { ...config.headers, Authorization: `Bearer ${authorization}` }
      }

      return config
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error)
    },
  )

  //set up the response interceptor

  // Add a response interceptor
  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      return response
    },
    function(error) {
      // Do something with response error
      handleError(error, dispatch)
      return Promise.reject(error)
    },
  )

  //make call here
  process(instance)
    .then(response => {
      success(response)
    })
    .catch(error => {
      failure(error)
    })
}

const doPatch = (
  dispatch,
  path,
  data = {},
  successHandler,
  errorHandler,
  skipAuthHeader = false,
  config = {},
) => {
  handleApiCall(
    dispatch,
    axios => axios.patch(path, data),
    response => successHandler(response),
    error => {
      errorHandler(error)
    },
    skipAuthHeader,
  )
}

const doPut = (
  dispatch,
  path,
  data = {},
  successHandler,
  errorHandler,
  skipAuthHeader = false,
  config = {},
) => {
  handleApiCall(
    dispatch,
    axios => axios.put(path, data),
    response => successHandler(response),
    error => {
      errorHandler(error)
    },
    skipAuthHeader,
  )
}

const doGet = (
  dispatch,
  path,
  params = {},
  successHandler,
  errorHandler,
  skipAuthHeader = false,
  config = {},
) => {
  handleApiCall(
    dispatch,
    axios => axios.get(path, { ...config, params }),
    response => successHandler(response),
    error => {
      errorHandler(error)
    },
    skipAuthHeader,
  )
}

const doPost = (
  dispatch,
  path,
  data = {},
  successHandler,
  errorHandler,
  skipAuthHeader = false,
  config = {},
) => {
  handleApiCall(
    dispatch,
    axios => axios.post(path, data, config),
    response => successHandler(response),
    error => {
      errorHandler(error)
    },
    skipAuthHeader,
  )
}

export default ({ dispatch }) => next => action => {
  if (action.type === MAKE_API_CALL) {
    const {
      method,
      path,
      data,
      params,
      successHandler,
      errorHandler,
      skipAuthHeader,
      config,
    } = action.payload

    switch (method) {
      case 'put':
        return doPut(dispatch, path, data, successHandler, errorHandler, skipAuthHeader, config)
      case 'post':
        return doPost(dispatch, path, data, successHandler, errorHandler, skipAuthHeader, config)
      case 'get':
        return doGet(dispatch, path, params, successHandler, errorHandler, skipAuthHeader, config)
      case 'patch':
        return doPatch(dispatch, path, data, successHandler, errorHandler, skipAuthHeader, config)
      default:
        return next(action)
    }
  } else {
    return next(action)
  }
}



// WEBPACK FOOTER //
// ./src/middlewares/kuwegoApiMiddleware.js